import {
  type CustomerFragmentFragment,
  type OrderFragmentFragment,
} from '@data/shopify/storefront/types'
import { type UserOrder } from '@lib/user/types'

/**
 * Parses Shopify customer order.
 */
export const parseShopifyOrder = (order: OrderFragmentFragment) => {
  const userOrder: UserOrder = {
    id: order.name,
    date: order.processedAt,
    paymentStatus: order.financialStatus ?? null,
    fulfillmentStatus: order.fulfillmentStatus,
    total: Number(order.totalPrice.amount),
    url: order.statusUrl,
  }

  return userOrder
}

/**
 * Gets user orders from Shopify customer with orders.
 */
export const getUserOrders = (shopifyCustomer?: CustomerFragmentFragment) => {
  const userOrders =
    shopifyCustomer?.orders?.edges
      ?.map((edge) => parseShopifyOrder(edge.node))
      ?.filter(Boolean) ?? []

  return userOrders
}
